import React from 'react';
import SiteHeader from '../components/SiteHeader';
import './StaticPage.css';

const ImpressumPage: React.FC = () => {
  return (
    <>
      <SiteHeader />
      <div className="static-page">
        <div className="container">
          <p className="eyebrow">Rechtliches</p>
          <h1>Impressum</h1>
          <p>
            <strong>Hoog & Rudorf GbR</strong>
          </p>
          <p>vertretungsberechtigte Gesellschafter: Luis Rudorf und Jannik Hoog</p>
          <p>
            Seestraße 17
            <br />
            83700 Rottach-Egern
          </p>
          <p>Telefon: 0 80 22 / 57 59</p>
          <p>E-Mail: jannik@elfhalbe.de</p>
          <p>UST-Id-Nr.: DE 460887713</p>
          <p>Redaktionell Verantwortliche: Jannik Hoog, Luis Rudorf, Seestraße 17, 83700 Rottach-Egern</p>
          <p>Zur Teilnahme an einem Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle sind wir nicht verpflichtet und grundsätzlich nicht bereit.</p>
        </div>
      </div>
    </>
  );
};

export default ImpressumPage;
